module.exports = __webpack_public_path__ + "static/media/imp.041cffc2.png";